import { homecontentsBrandcodes } from '../../constants';

export const footerDisclaimer = ({ comparisonUrl, fsgUrl }) => {
    return `<p>We recommend you read the Product Disclosure Statement (PDS) before you make a decision.</p>
            <p>Please note that when we display quotes on our comparison results page,
             they are indicative and subject to change based on further questions by the insurer.</p>
             <p>We do not compare all home insurers or products in the market.
              Any advice given above is general and does not take into account your objectives, financial situation or needs.
              You should consider whether the advice is suitable for you and your personal circumstances,
              and before you make any decision about whether to purchase a product, you should read the PDS for that product.
              A number of the home and contents insurance brands on our panel are arranged by Auto &amp; General Services Pty Ltd ACN 003 617 909
              on behalf of the insurer Auto &amp; General Insurance Company Limited ACN 111 586 353,
              both of which are related entities of Compare the Market Pty Ltd.
              Our relationship with those companies does not impact the integrity of our comparison service,
              and we continue to work hard to encourage brands that do not currently participate on our comparison service to come on board.</p>
              <p>For more information about the range of insurers and products we compare, how our service works,
              and how we make our money (remembering that the service is free for you to use),
              read our <a href="${comparisonUrl}" target="_blank">how our comparison works</a> page,
              and read our <a href="${fsgUrl}" target="_blank">Financial Services Guide (General Insurance Products)</a>.</p>
              <p>The Compare The Market website and trading name are owned by Compare The Market Pty Ltd ACN 117 323 378 AFSL 422926.</p>`;
};

export const trustedPartnerContent = () => {
    const trustedPartnerConfig = {
        title: 'Trusted Partners',
        description: 'Our Trusted Partners, for the purpose of your invitation to call, are:',
        reasons: [
            'the insurer that ranks in position 1 on our results page;',
            'any other insurer with whom you express an interest to contact, by commencing an online application or call enquiry; or',
            'if we are unable to provide you with any quotes, a specialised broker - Shielded Insurance Brokers.'
        ],
        disclaimer: ''
    };
    return trustedPartnerConfig;
};

export const redbookDisclosureContent = () => {
    const redbookDisclosureConfig = {
        title: '',
        description: ''
    };
    return redbookDisclosureConfig;
};

export const partnerBrands = () => [
    homecontentsBrandcodes.BUDD,
    homecontentsBrandcodes.VIRG,
    homecontentsBrandcodes.WOOL,
    homecontentsBrandcodes.HUDD,
    //homecontentsBrandcodes.HONY,
    //homecontentsBrandcodes.HBOQ,
    homecontentsBrandcodes.EXIG,
    homecontentsBrandcodes.BUPA,
    homecontentsBrandcodes.AHM,
    homecontentsBrandcodes.EXCL
];

export const crossSellOtherVerticalsOnResults = () => true;
export const showNoResultsOverlayGenericMessage = () => false;
export const resultsScreenDefaultDisplayMode = () => 'row';

export const contactDetailOptInPrivacyMessage = ({ companyName, fsgUrl, privacyPolicyUrl }) => {
    return `I have read and accept ${companyName}'s
        <a href="${privacyPolicyUrl}" target="_blank" data-id="websitePrivacyPolicyFormTermsLink" rel="noopener noreferrer">Privacy Collection Notice</a> and
        <a href="${fsgUrl}" target="_blank" data-id="websiteFinancialServicesGuideLink" rel="noopener noreferrer">Financial Services Guide</a>,
        including that ${companyName} may email and SMS me about the services it provides. By providing a contact number, I invite ${companyName} or its
        <a id="trustedPartnersOpen" data-id="trustedPartnersOpen">Trusted Partners</a> to call me during the call centre
        <a id="callCentreHoursOpen" data-id="callCentreHoursOpen">opening hours</a>
        to discuss the potential purchase of a home and contents or car insurance policy.`;
};

export const enableResultsFeatureAccordion = () => false;
export const showPriceConfidenceBanner = () => false;
export const spinnerColour = () => '#1c3e94';
export const spinnerType = () => 'Default';
